import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { SupportTicket } from './useSupportTickets';

export interface SupportMessage {
  id: string;
  ticket_id: string;
  user_id: string;
  content: string;
  is_internal_note: boolean;
  attachments: string[];
  created_at: string;
  read_at: string | null;
  profiles?: {
    username: string;
    main_photo_url: string | null;
  };
}

export const useTicketDetails = (ticketId: string) => {
  const ticketQuery = useQuery({
    queryKey: ['support-ticket', ticketId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('support_tickets')
        .select('*')
        .eq('id', ticketId)
        .single();

      if (error) throw error;
      return data as SupportTicket;
    },
    enabled: !!ticketId,
  });

  const messagesQuery = useQuery({
    queryKey: ['support-messages', ticketId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('support_messages')
        .select(`
          *,
          profiles:user_id (
            username,
            main_photo_url
          )
        `)
        .eq('ticket_id', ticketId)
        .order('created_at', { ascending: true });

      if (error) throw error;
      return data as SupportMessage[];
    },
    enabled: !!ticketId,
  });

  return {
    ticket: ticketQuery.data,
    messages: messagesQuery.data,
    isLoading: ticketQuery.isLoading || messagesQuery.isLoading,
    error: ticketQuery.error || messagesQuery.error,
    refetchMessages: messagesQuery.refetch,
  };
};
